var exports = {
  "VH": "ForwardMessagePreview.module__preview___WER3Q2",
  "Qs": "ForwardMessagePreview.module__content___WER3Q2",
  "iU": "ForwardMessagePreview.module__message___WER3Q2",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___WER3Q2",
  "oh": "ForwardMessagePreview.module__edited___WER3Q2",
  "kp": "ForwardMessagePreview.module__attachmentRow___WER3Q2",
  "$r": "ForwardMessagePreview.module__attachmentIcon___WER3Q2",
  "eI": "ForwardMessagePreview.module__attachmentSummary___WER3Q2",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___WER3Q2",
  "vH": "ForwardMessagePreview.module__thumbnailStack___WER3Q2",
  "xn": "ForwardMessagePreview.module__thumbnail___WER3Q2",
  "q_": "ForwardMessagePreview.module__thumbnailImage___WER3Q2",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___WER3Q2",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___WER3Q2",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___WER3Q2",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___WER3Q2",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___WER3Q2",
  "uZ": "ForwardMessagePreview.module__playIcon___WER3Q2",
  "mB": "ForwardMessagePreview.module__overflowCount___WER3Q2",
};

module.exports = exports;
